import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, AreaChart, Area } from "recharts";
import api, { money } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then(r => setD(r.data)); }, []);
  if (!d) return <div className="h-40 shimmer" />;
  return (
    <div>
      <AdminHeader title="Analytics" subtitle="Sales performance & insights" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[["Revenue", money(d.revenue)], ["Orders", d.total_orders], ["AOV", money(d.aov)], ["Customers", d.customer_count]].map(([l, v]) => (
          <div key={l} className="bg-white border border-sage/30 rounded-sm p-5"><div className="text-xs uppercase text-forest/50">{l}</div><div className="serif text-3xl">{v}</div></div>
        ))}
      </div>
      <div className="bg-white border border-sage/30 rounded-sm p-6 mb-6">
        <h3 className="serif text-2xl mb-4">Sales Over Time</h3>
        <ResponsiveContainer width="100%" height={280}>
          <AreaChart data={d.sales_series}>
            <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#5B705C" stopOpacity={0.3} /><stop offset="100%" stopColor="#5B705C" stopOpacity={0} /></linearGradient></defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e6e0d4" />
            <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(v) => v.slice(5)} /><YAxis tick={{ fontSize: 10 }} /><Tooltip />
            <Area type="monotone" dataKey="sales" stroke="#263D2B" strokeWidth={2} fill="url(#g)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="bg-white border border-sage/30 rounded-sm p-6">
        <h3 className="serif text-2xl mb-4">Top Products by Units Sold</h3>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={d.top_products} layout="vertical" margin={{ left: 40 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e6e0d4" />
            <XAxis type="number" tick={{ fontSize: 10 }} /><YAxis type="category" dataKey="name" tick={{ fontSize: 10 }} width={140} /><Tooltip />
            <Bar dataKey="units" fill="#263D2B" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
